import React from "react";

// Config
import { capturePages } from "../../config/values";

// Components
import CaptureSteps from "../../components/CaptureSteps";
import SectionWrapper from "../../components/SectionWrapper";

const AddInjuryPage = () => {
  return (
    <SectionWrapper>
      <CaptureSteps page={capturePages.INJURY} />
    </SectionWrapper>
  );
};

export default AddInjuryPage;
